import { DataHandlerScene, type Scene } from "luxedo-data"
import { ProgressContext } from "./ProgressContext.svelte"
import { LuxedoRPC, type JobStatus } from "luxedo-rpc"

class DirectUploadProgressCtx extends ProgressContext<Scene> {
	async processUpload(sceneId: number) {
		await LuxedoRPC.api.scene.project_upload_process(sceneId)
	}

	/** Every scene job (render, direct-upload processing, preview) ends by writing render_ver. */
	protected completionMarker(id: number): string | null {
		const scene = DataHandlerScene.get(id)
		if (!scene) return null
		return String(scene.render_ver?.getTime() ?? "none")
	}

	protected describe(id: number): string {
		return `scene ${id}`
	}

	protected async fetchStatuses(ids: Array<number>): Promise<{ [id: string]: JobStatus }> {
		return (await LuxedoRPC.api.scene.project_processing_status(ids, "project")).status
	}

	async getCompletedData(id: number): Promise<Scene> {
		await DataHandlerScene.pull([id])
		const scene = DataHandlerScene.get(id)
		return scene
	}
}

export const DirectUploadProgressContext = new DirectUploadProgressCtx({
	progress: "proj_upload_set_progress",
	complete: "proj_upload_process_complete",
	fail: "proj_upload_process_fail",
	queued: "proj_upload_queued",
})
